<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <app-bar :title="`Xuất sim`"/>
        <v-flex xs12 sm12 md12 lg12 xl12>
          <v-card>
            <v-card-text class="pa-10">
              <v-layout row wrap>
                <v-flex xs12 sm3>
                  <v-text-field :value="loggedUser.accountName" label="Xuất từ" disabled></v-text-field>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-autocomplete
                    v-model="form.accountId"
                    label="Xuất đến"
                    :items="dealers"
                    item-text="name"
                    item-value="id"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-text-field v-model="form.refCode" label="Mã phiếu xuất hàng"></v-text-field>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-text-field v-model="form.remark" label="Ghi chú"></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 sm12 md12 lg12 xl12>
          <v-card flat>
            <v-tabs slider-color="primary" color="grey lighten-2">
              <v-tab v-if="!loggedUser.isProvider" ripple>Chọn sim để xuất</v-tab>
              <v-tab v-if="loggedUser.isProvider" ripple>Xuất sim từ file</v-tab>
              <v-tab-item v-if="!loggedUser.isProvider">
                <mover
                  :leftTitle="`Sim sẵn có `"
                  :rightTitle="`Sim đã chọn `"
                  :datasource="simsByLoggedAccount"
                  :firstLineProp="`iccId`"
                  :secondLineProp="`phone`"
                  @output="getSelectedSim($event)"
                />
              </v-tab-item>
              <v-tab-item v-if="loggedUser.isProvider">
                <v-card class="elevation-0">
                  <v-toolbar card color="white">
                    <v-btn outline round color="primary" @click="pickFile" v-model="fileName">
                      {{fileName}}
                      <v-icon right>attach_file</v-icon>
                    </v-btn>
                    <input
                      type="file"
                      style="display: none"
                      ref="fileUpload"
                      accept=".xlsx, .xls, .csv"
                      @change="onFilePicked"
                    >
                    <v-spacer></v-spacer>
                    <v-btn
                      flat
                      round
                      color="success"
                      href="/static/Export_Sim_Template.xlsx"
                      target="_blank"
                    >Tải file mẫu
                      <v-icon right>cloud_download</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-text class="pa-0">
                    <export-sim-table :isLoading="isLoading" :datasource="simViewModels"/>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat @click="cancel()">Nhập lại</v-btn>
              <v-btn color="primary" @click="submit()" :loading="isMovingSim">Xuất sim</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import * as Utils from '@/utils';
import * as Auth from '@/utils/auth';
import XLSX from 'xlsx';
import AppBar from '@/components/appbar';
import ExportSimTable from './components/exportlist';
import Mover from '@/components/mover';

export default {
  components: {
    ExportSimTable,
    AppBar,
    Mover
  },
  data () {
    return {
      dealers: [],
      fileName: 'Chọn file',
      simViewModels: [],
      isLoading: false,
      simsByLoggedAccount: [],
      form: {
        accountId: '',
        simIds: [],
        refCode: '',
        remark: ''
      },
      isMovingSim: false
    };
  },
  computed: {
    ...mapGetters(['loggedUser', 'sims'])
  },

  watch: {
    loggedUser (newValue, oldValue) {
      if (!this.simsByLoggedAccount.length) this.getSimsByAccount(newValue);
    }
  }, 

  mounted () {
    if (this.sims.length <= 10) this.getSims(Utils.pagination);
    this.getDealers()
      .then(res => {
        this.dealers = res;
      })
      .catch(err => console.log(err));

    this.getSimsByAccount();
  },
  methods: {
    ...mapActions([
      'getSims',
      'getSimByIccId',
      'getDealers',
      'getSimByAccount',
      'moveSims'
    ]),
    pickFile () {
      this.$refs.fileUpload.click();
    },
    onFilePicked (e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.parseExcelFileToJson(files[0]);
      }
    },
    parseExcelFileToJson (f) {
      this.isLoading = true;

      this.fileName = `Đã chọn: ${f.name}`;

      let reader = new FileReader();
      reader.readAsBinaryString(f);

      reader.onload = e => {
        let data = e.target.result;
        let workbook = XLSX.read(data, {
          type: 'binary'
        });
        let first_worksheet = workbook.Sheets[workbook.SheetNames[0]];
        let content = XLSX.utils.sheet_to_json(first_worksheet, {
          header: 1
        });

        this.simViewModels = [];
        this.form.simIds = [];

        content.map((item, index) => {
          if (index > 0) {
            this.getSimByIccId(item[2]).then(sim => {
              let extend = {
                ownerName: item[1],
                iccId: item[2],
                phone: item[3],
                telco: item[4],
                isValid: false
              };

              extend.isValid = sim ? true : false;

              let merge = sim
                ? {
                  ...sim,
                  ...extend
                }
                : extend;
              if (merge.iccId && merge.phone) {
                this.simViewModels.push(merge);

                if (merge.isValid) {
                  this.form.simIds.push(merge.id);
                }
              }
            });
          }
          return 0;
        });
        this.isLoading = false;
      };
    },
    getSelectedSim (list) {
      this.form.simIds = [];
      list.map(a => {
        this.form.simIds.push(a.id);
        return 0;
      });
    },
    cancel () {
      window.location.reload();
    },
    submit () {
      this.isMovingSim = true;
      this.moveSims(this.form)
        .then(res => {
          this.isMovingSim = false;
          window.getApp.showMessage('Xuất sim thành công');
          window.history.back();
        })
        .catch(_ => {
          this.isMovingSim = false;
          window.getApp.showMessage(
            'Xuất sim thất bại, vui lòng thử lại',
            'error'
          );
        });
    },

    getSimsByAccount (user) {
      let loggedUser = user ? user : Auth.getLoggedUser();
      if (!loggedUser) return;
      let accountId = loggedUser.accountId;
      let params = Object.assign({ accountId }, Utils.pagination);

      this.getSimByAccount(params)
        .then(res => {
          this.simsByLoggedAccount = res;
        })
        .catch(err => console.log(err));
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/sim/export.vue